import script from "./card-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./card-widget-ly.vue?vue&type=script&setup=true&lang=js"

import "./card-widget-ly.vue?vue&type=style&index=0&id=ef9f4bf6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef9f4bf6"]])

export default __exports__